import { getSocialMedias } from "../../backend/socialMedia/socialMedia";
import { SocialMedia } from "../../types/socialMedia/socialMedia";

const SocialMediaIcon = ({
  socialMedia,
  size,
  useFooter = false,
  useMenu = false,
}: {
  socialMedia: SocialMedia;
  size: string;
  useFooter?: boolean;
  useMenu?: boolean;
}) => {
  return (
    <a
      style={{ ...styles.socialIconContainer, width: size, height: size }}
      onMouseOver={(e) => {
        (e.currentTarget.children[0] as HTMLElement).style.opacity = "0";
        (e.currentTarget.children[1] as HTMLElement).style.opacity = "1";
      }}
      onMouseOut={(e) => {
        (e.currentTarget.children[0] as HTMLElement).style.opacity = "1";
        (e.currentTarget.children[1] as HTMLElement).style.opacity = "0";
      }}
      href={socialMedia.redirectLink}
      target="_blank"
      onClick={(e) => {
        (e.currentTarget.children[0] as HTMLElement).style.opacity = "1";
        (e.currentTarget.children[1] as HTMLElement).style.opacity = "0";
      }}
    >
      <img
        src={
          useMenu
            ? socialMedia.menuIconPath
            : useFooter
            ? socialMedia.footerIconPath
            : socialMedia.iconPath
        }
        style={{
          ...styles.socialIcon,
          width: size,
          height: size,
          opacity: "1",
        }}
        alt="медіа"
      />
      <img
        src={
          useMenu
            ? socialMedia.menuIconPath
            : useFooter
            ? socialMedia.footerHoverIconPath
            : socialMedia.hoverIconPath
        }
        style={{
          ...styles.socialIcon,
          width: size,
          height: size,
          opacity: "0",
        }}
        alt="медіа"
      />
    </a>
  );
};

const SocialMediaRow = ({
  rowStyle = {},
  useFooter = false,
  useMenu = false,
  size = "min(5rem, 15vw)",
  gap = "min(1rem, 5vw)",
}: {
  rowStyle?: React.CSSProperties | undefined;
  useFooter?: boolean;
  useMenu?: boolean;
  size?: string;
  gap?: string;
}) => {
  const socialMediaList = getSocialMedias();

  return (
    <div style={{ ...styles.iconRow, ...rowStyle, gap: gap }}>
      {socialMediaList.map((item) => (
        <SocialMediaIcon socialMedia={item} useFooter={useFooter} useMenu={useMenu} size={size} />
      ))}
    </div>
  );
};

export default SocialMediaRow;

const styles: Record<string, React.CSSProperties> = {
  iconRow: {
    display: "flex",
    flexDirection: "row",
  },
  socialIconContainer: {
    width: "min(5rem, 15vw)",
    height: "min(5rem, 15vw)",
    cursor: "pointer",
  },
  socialIcon: {
    transition: "all 0.3s ease",
    position: "absolute",
  },
};
